import { VUE_APP_ENV } from '@/transformEnv';

/**
 * @description Функция регистрации.
 */
export const REGISTRATION_FEATURE = 'registration';

/**
 * @description Функция восстановления пароля.
 */
export const FORGOT_PASSWORD_FEATURE = 'forgot-password';

/**
 * @description Функция убрана из текущей версии.
 * @param {string} feature Идентификатор функции.
 * @returns {boolean}
 */
export const isRemovedFeature = {
  demo: (feature) => (
    feature === REGISTRATION_FEATURE
    || feature === FORGOT_PASSWORD_FEATURE
  ),
}[VUE_APP_ENV] || (() => false);
